import { DOMAINS } from 'utils/Constants'
import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()

const PRODUCTION_DOMAIN_KEYS = {
  [DOMAINS.CARE_GUIDE]: 'MWBIjsXgZvxidlHU4qwLhLzgjyRHdsXQ',
  [DOMAINS.BABY_SITTER_JOBS]: '0g28MNDnpBH9bHKSlzBkTCHbqkBTxWTB',
  [DOMAINS.CLEANING_LADY]: 'Ai6mB7pQi1hseS2Bzle7nnS85TUBhTMm',
  [DOMAINS.CHILD_CARE_ADVANTAGE]: 'wZwOGE7gsVraZER3SDgY5ZVCREEi7QGi',
  [DOMAINS.CANADIAN_NANNY]: 'lZnNGZEA5kNkiNoSfTDhW9H98hsslT2L',
  [DOMAINS.HOUSE_KEEPER]: 'JwduvmoCsbBgEQrdG79t8OPvwTc2ibIS',
  [DOMAINS.HOUSE_SITTER]: 'RssK49b4eilvega8ID4x4YTPlvzchClD',
  [DOMAINS.SITTER]: 'iiGtTzGNouX4CsvBQKrwqBF8AVLjSIMS',
  [DOMAINS.PET_SITTER]: 'SITbPk2tYbV1B8gT0CUuJyGFrOLdo39J',
  [DOMAINS.ELDER_CARE]: 'KJAiZwpju5zvhezSaKAvffCDzmfADzHB',
  [DOMAINS.CARE_PROVIDER]: '3LGbFmwMTG6FoJ7ddmpfjtXaUS9cDn8N',
  [DOMAINS.MOM_TERESA]: 'MixH1XLxSgMA3S397mxn69Ka7Nyk4l1d',
  [DOMAINS.MEET_A_CARPENTER]: '5MLIscyeFAH2dIAEvNV2wXLirLIGo6c9',
  [DOMAINS.MEET_A_GARDENER]: 'sx9eyYZdrhxtpxfiEqN9oul2HLlNJpSy',
  [DOMAINS.MEET_A_LANDSCAPER]: 'QHEP3ORGOIuC2NK7mJhEuZ6PAw9XgVfm',
  [DOMAINS.MEET_AN_ACCOUNTANT]: 'GrTS03SR3MDdu3IwdI6da1YbzKssJ2cZ',
  [DOMAINS.MEET_AN_ENGINNER]: 'P8lPLM62MpMdn21Nx7FSkzC0EQGSdyIN',
  [DOMAINS.MEET_A_CHEF]: 'egXl9MfrZYKa8i54MdS7piKEsESgm0D4',
  [DOMAINS.MEET_A_HANDYMAN]: 'OgfnQ72wjGQEHFelLBxRZivkFQoDVwsY',
  [DOMAINS.MEET_A_MECHANIC]: '9pDIBL6cwW75R7X89x8hGCD7pTswbOWY',
  [DOMAINS.MEET_AN_ELECTRICIAN]: 'dcnXiqaHAcmaLEwLavz8MknKvGrQWHVJ',
  [DOMAINS.MEET_A_PAINTER]: 'xEPVnXa4RhaWBhRUwQd3GwQYZzFlcchF',
  [DOMAINS.MEET_A_PHOTOGRAPHER]: 'K6aJfHqaoakFPkh6sYsgIOyx27CtmvWo',
  [DOMAINS.MEET_A_PROGRAMMER]: 'eQDOeK4Fqxc2GhAS0nqJUBf1YpUjUWya',
  [DOMAINS.MEET_A_ROOFER]: 'UwM0Wf6cYR3FqwVyHyixUEKCrJpl4wxz',
  [DOMAINS.MEET_A_SECURITY_GUARD]: 'e3DUVbVrNkU7DWFm7OIz52OSrS3lQ9Lm',
  [DOMAINS.MEET_A_TUTOR]: 'Kk7fgaPz6rpI0sHSxm2AXRlQO2bnS4mE',
  [DOMAINS.MEET_A_WEB_DEVELOPER]: 'QyPWNDndIfx8mDeseyC1xJRfkCAdZoaW',
  [DOMAINS.MEET_A_PLUMBER]: '3x2mVuvRDnPJcfleRiIQa0IwlAX4I7lz',
  [DOMAINS.MEET_A_RENOVATOR]: 'hcGiF8PLGnTHb8VRFtDiWXmhk5btLEZM',
  [DOMAINS.MEET_A_SALESMAN]: 'yqXMnfnis7zpA79RqSJMBV3Sy96ViYbM',
  [DOMAINS.MEET_A_TRUCK_DRIVER]: 'WE6CKRsy5NMmKW5lbO0mIHcm6KoUGIZr',
  [DOMAINS.MEET_A_VIDEOGRAPHER]: '8piLH20n9xz0Js0FrmSsdrlgErwhXVd4',
  [DOMAINS.MEET_A_WRITER]: 'x4EdmWVk3BToSUxczPQ6wAjbUUQn1RM2',
}

const STAGING_KEY = 'IZQ1UsNsr98HXWCP9C2paWulaFbyo2n3'

const domainKey = (domain) => {
  const { NODE_ENV } = publicRuntimeConfig

  if (NODE_ENV === 'staging') {
    return STAGING_KEY
  }

  if (NODE_ENV === 'production' && domain) {
    return PRODUCTION_DOMAIN_KEYS[domain]
  }

  return null
}

export const Initialize = (domain) => {
  var analytics = (window.analytics = window.analytics || [])
  if (!analytics.initialize)
    if (analytics.invoked)
      window.console && console.error && console.error('Segment snippet included twice.')
    else {
      analytics.invoked = !0
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
      ]
      analytics.factory = function (t) {
        return function () {
          var e = Array.prototype.slice.call(arguments)
          e.unshift(t)
          analytics.push(e)
          return analytics
        }
      }
      for (var t = 0; t < analytics.methods.length; t++) {
        var e = analytics.methods[t]
        analytics[e] = analytics.factory(e)
      }
      analytics.load = function (t, e) {
        var n = document.createElement('script')
        n.type = 'text/javascript'
        n.async = !0
        n.src = 'https://cdn.segment.com/analytics.js/v1/' + t + '/analytics.min.js'
        var a = document.getElementsByTagName('script')[0]
        a.parentNode.insertBefore(n, a)
        analytics._loadOptions = e
      }
      analytics.SNIPPET_VERSION = '4.1.0'
      analytics.load(domainKey(domain))
    }
}

export const PageView = (pageName) => {
  if (pageName) {
    window.analytics.page(pageName)
  } else {
    window.analytics.page()
  }
}

export const TrackEvent = (eventName, metadata = {}) => {
  window.analytics.track(eventName, metadata)
}

export const SetDimensions = (metadata) => {
  if (!metadata) {
    return
  }

  window.analytics.identify(metadata)
}

export const Group = (id, metadata) => {
  if (!metadata || !id) {
    return
  }

  window.analytics.group(id, metadata)
}
